import React, {
	useContext,
	useEffect,
	useReducer,
	useRef,
	useState,
} from "react";
import { Link, useNavigate } from "react-router-dom";
//import {NavLink} from 'react-router-dom';
//import loadable from "@loadable/component";
//import pMinDelay from "p-min-delay";
import { Button, Card, Dropdown, Form, Modal, OverlayTrigger, Popover, Spinner } from "react-bootstrap";
import logo from "../../media/images/logo.png";

import "./home.scss";


//Import Components
import { ThemeContext } from "../../context/ThemeContext";
import expertiseImg from '../../media/images/proDashboardAssets/expertiseImg.png'
import earningsImg from '../../media/images/proDashboardAssets/earningsImg.png'
import documentImg from '../../media/images/proDashboardAssets/documentImg.png'
import changeAvatarImg from '../../media/images/proDashboardAssets/changeAvatarImg.png'
import banckImg from '../../media/images/proDashboardAssets/bankImg.png'
import targetAI from '../../media/images/proDashboardAssets/targetAI.png'
import helpCustomerImg from '../../media/images/proDashboardAssets/helpCustomerImg.png'
import giveFeedbackImg from '../../media/images/proDashboardAssets/giveFeedbackImg.png'
import businessImg from '../../media/images/proDashboardAssets/businessImg.png'


import axios from 'axios';
import Pic1 from "./../../images/popular-img/review-img/pic-1.jpg";
import Pic2 from "./../../images/popular-img/review-img/pic-2.jpg";
import Pic3 from "./../../images/popular-img/review-img/pic-3.jpg";
import Finance from "./subComponents/finance";
import Reports from "./subComponents/reports";
import EncomeDetailsLeftComponent from "./subComponents/encomeDetailsLeftComponent";
import EncomeDetailsRightComponent from "./subComponents/encomeDetailsRightComponent";
import TransactionHistory from "./subComponents/transactionHistory";
import TotalEarning from "./subComponents/totalEarning";
import { useSelector } from "react-redux";
import AvailableJobs from "./subComponents/availableJobs";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import CustomerDashboard from "./customerDashboard/customerDashboard";
import { FaHandHoldingDollar } from "react-icons/fa6";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import TextArea from "../../jsx/components/fields/textArea";
import SendVideoLink from "../sendVideoLink/sendVideoLink";
import { setAccountDetailsModalTriggerRedux, setCurrentPage, setDocumentsModalTriggerRedux, setExpertiseTriggerRedux, setFeedbackModalRedux, setUserDetails, setUserProfileTab } from "../../feature/userData/userData";
import { useDispatch } from "react-redux";
import { getConnectedAccountBalanceByIdApi } from "../../service/api/paymentGateway/getConnectedAccountBalanceById";
import { getConnectedAccountStatusById } from "../../service/api/paymentGateway/getConnectedAccountStatusById";
import { getEarningsInformationApi } from "../../service/api/paymentGateway/getEarningsInformation";
import { setFinanceData } from "../../feature/financeData/financeData";
import ErrorResponseModal from "../../component/errorModal/errorResponseModal";
import SkeletonDivElement from "../../component/skeletonTableRow/skeletonDivElement";
import InputField from "../../jsx/components/fields/inputField";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import NewProDashboard from "./newProDashboard/newProDashboard";
import { userById } from "../../service/api/user/userById";
import Dashboard1 from "../../component/Dashboard";
import { getCounterApi } from "../../service/api/ticket/serviceCounters";
import updateTicketSummaryApi from "../../service/api/ticket/updateTicketSummary";
import LocalProDashboard from "./localProDashboard/localProDashboard";
import ProOptionDashboard from "./proOptionDashboard/proOptionDashboard";

const orderBlog = [
	{ id: 1, image: Pic1, number: 1 },
	{ id: 2, image: Pic2, number: 1 },
	{ id: 3, image: Pic3, number: 1 },
	{ id: 4, image: Pic1, number: 1 },
];

const reducer = (previousState, updatedState) => ({
	...previousState,
	...updatedState,
});



const Home = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { role, connectedAccountId, proDocumentsFlag, proExpertiseFlag, proOnboardingFlag, serviceRequestFlagPro, isSignUpFlag, proOptionFlag } = useSelector((state) => state.user);
	const { permissionArr } = useSelector((state) => state.user);


	const permissionArray = permissionArr[0] || [];
	const [dropSelect, setDropSelect] = useState("Other");
	const { changeBackground } = useContext(ThemeContext);
	const [detailsModal, setDetailsModal] = useState(false);
	const [notesModal, setNotesModal] = useState(false);

	const [connectedAccStatus, setConnectedAccStatus] = useState(false);
	const [cardPaymentsCheck, setCardPaymentsCheck] = useState(false);
	const [transfersCheck, setTransfersCheck] = useState(false);

	const [responceMsg, setResponceMsg] = useState("");
	const [toasterType, setToasterType] = useState("");
	const [handleToaster, setHandleToaster] = useState(false);

	const [serviceSummaryMetaData, setServiceSummaryMetaData] = useState({});
	const [proCheckInfoModalTrigger, setProCheckInfoModalTrigger] = useState(false);

	const [proDiagnosis, setProDiagnosis] = useState("");
	const [proEstimatedCostMin, setProEstimatedCostMin] = useState(``);
	const [proEstimatedCostMax, setProEstimatedCostMax] = useState(``);
	const [proRecommendedSolution, setProRecommendedSolution] = useState(0);

	const [proDiagnosisErr, setProDiagnosisErr] = useState(false);
	const [proRecommendedSolutionErr, setProRecommendedSolutionErr] = useState(false);
	const [updateTicketSummaryLoading, setUpdateTicketSummaryLoading] = useState(false);

	const [toggleForProOption, setToggleForProOption] = useState(true);
	const handleProDiagnosis = (e) => {
		setProDiagnosisErr(false);
		setProDiagnosis(e.target.value);
	};

	const handleProEstimatedCostMin = (e) => {
		setProEstimatedCostMin(
			e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
		);
	};

	const handleProEstimatedCostMax = (e) => {
		setProEstimatedCostMax(
			e.target.value.replace(/[^\d.]/g, "").replace(/(\.\d*)\./g, "$1")
		);
	};

	useEffect(() => {
		if (+proEstimatedCostMin > +proEstimatedCostMax) {
			setProEstimatedCostMax((+proEstimatedCostMin * 1.2).toFixed(2));
		}
	}, [proEstimatedCostMin])

	useEffect(() => {
		setProRecommendedSolutionErr(false);
	}, [proRecommendedSolution])

	useEffect(() => {
		changeBackground({ value: "light", label: "Light" });
	}, []);

	useEffect(() => {
		dispatch(setCurrentPage("Dashboard"));
	}, []);

	const [state, setState] = useReducer(reducer, { orderBlog: orderBlog });
	const handleCountAdd = (e) => {
		let temp = state.orderBlog.map((data) => {
			if (e === data.id) {
				return { ...data, number: data.number + 1 };
			}
			return data;
		});
		setState({ orderBlog: temp });
	};
	const handleCountMinus = (e) => {
		let temp = state.orderBlog.map((data) => {
			if (e === data.id) {
				return {
					...data,
					number: data.number > 0 ? data.number - 1 : data.number,
				};
			}
			return data;
		});
		setState({ orderBlog: temp });
	};

	const [isServiceExpand, setIsServiceExpand] = useState(false);
	const [currentServiceReqId, setCurrentServiceReqId] = useState(0);
	const handleServiceExpand = (currentServiceReqId) => {
		setIsServiceExpand(!isServiceExpand);
		setCurrentServiceReqId(currentServiceReqId);
	};

	// Tips and Tricks functions
	const [tipsSliderSteps, setTipsSliderSteps] = useState(serviceRequestFlagPro != 1 ? 1 : 5);
	const [tipsModalTrigger, setTipsModalTrigger] = useState(false);
	const handleOpenTipsModal = () => {
		setTipsModalTrigger(true);
	}
	const handleCloseTipsModal = () => {
		setTipsModalTrigger(false);
	}

	useEffect(() => {
		if (!tipsModalTrigger) {
			const interval = setInterval(() => {
				setTipsSliderSteps(prevValue => {
					return prevValue >= 8 ? serviceRequestFlagPro != 1 ? 1 : 5 : prevValue + 1;
				});
			}, 7000);
			return () => clearInterval(interval);
		}
	}, [tipsModalTrigger]);

	// Balance and trasactions functions
	const [availableBalanceObj, setAvailableBalanceObj] = useState({});
	const getConnectedAccountBalanceByIdFn = () => {
		let data = {
			connected_account_id_ids: connectedAccountId,
		}
		dispatch(
			getConnectedAccountBalanceByIdApi(data,
				(res) => {
					// console.log(res.data.data);
					setAvailableBalanceObj(res.data.data)
				},
				(res) => {
					// console.log(res)
				})
		)
	}

	const getConnectedAccountStatus = () => {
		let details = {
			connected_account_id_ids: connectedAccountId,
		}
		dispatch(
			getConnectedAccountStatusById(details,
				(res) => {
					// console.log(res?.data?.data)
					// console.log(res?.data?.data?.connected_account_status)
					setConnectedAccStatus(res?.data?.data?.connected_account_status)
					if (res?.data?.data?.connected_account_details.capabilities.card_payments === "active") { setCardPaymentsCheck(true) }
					if (res?.data?.data?.connected_account_details.capabilities.transfers === "active") { setTransfersCheck(true) }

					// console.log(connectedAccBank, connectedAccCurrency, connectedAccLast4)
				},
				(res) => {
					// console.log(res?.data)
				})
		)
	}

	useEffect(() => {
		if (!permissionArray.includes("SCAN TAB")) {
			// getConnectedAccountBalanceByIdFn();
			// getConnectedAccountStatus();
			getEarningsInformationFn();
		}
	}, [connectedAccountId]);

	let USDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	});

	const [totalEarning, setTotalEarning] = useState(0);
	const [totalFees, setTotalFees] = useState(0);
	const [totalProEarnings, setTotalProEarnings] = useState(0);
	const [refundAmount, setRefundAmount] = useState(0);

	const [proLastWithdrawalObj, setProLastWithdrawalObj] = useState({});
	const [proLastEarningObj, setProLastEarningObj] = useState({});
	const [connectedAccsArr, setConnectedAccsArr] = useState([]);
	const [distinationAccId, setDistinationAccId] = useState('');

	const getEarningsInformationFn = () => {
		let details = {};
		dispatch(
			getEarningsInformationApi(
				details,
				(res) => {

					// console.log(res?.data?.data?.connected_account_balance_info, 'connected_account_balance_info')
					setAvailableBalanceObj(res?.data?.data?.connected_account_balance_info);

					// console.log(res?.data?.data?.connected_account_info, 'connected_account_info')

					setTotalEarning(res?.data?.data?.total_earnings_amount_float / 100);
					setTotalProEarnings(res?.data?.data?.total_pro_earnings / 100);
					setTotalFees(res?.data?.data?.total_application_fee / 100);
					res?.data?.data?.total_refund_amount_float && setRefundAmount(res?.data?.data?.total_refund_amount_float / 100);

					dispatch(setFinanceData(res?.data?.data))

					res?.data?.data?.pro_last_withdrawal && setProLastWithdrawalObj(res?.data?.data?.pro_last_withdrawal);
					res?.data?.data?.pro_last_earning && setProLastEarningObj(res?.data?.data?.pro_last_earning);

					setConnectedAccStatus(res?.data?.data?.connected_account_info?.connected_account_status)
					if (res?.data?.data?.connected_account_info?.connected_account_details?.capabilities.card_payments === "active") { setCardPaymentsCheck(true) }
					if (res?.data?.data?.connected_account_info?.connected_account_details?.capabilities.transfers === "active") { setTransfersCheck(true) }

					setConnectedAccsArr(res?.data?.data?.connected_account_info?.connected_account_details?.external_accounts?.data);
					setDistinationAccId(res?.data?.data?.connected_account_info?.connected_account_details?.external_accounts?.data[0]?.id)



				},
				(res) => {
					// console.log(res?.data?.data);
				}
			)
		);
	};

	const [flagsLoading, setFlagsLoading] = useState(true);

	function handleGetUserById() {
		setFlagsLoading(true);
		let details = {
			user_id_ids: localStorage.getItem("user_id"),
			role_id_int: localStorage.getItem("roleId"),
			user_impersonate_flag: 0,
		};

		dispatch(
			userById(
				details,
				(res) => {
					dispatch(setUserDetails(res.data.data));
					setFlagsLoading(false);
				},
				(err) => {
					setFlagsLoading(false);
				}
			)
		);
	}

	useEffect(() => {
		if (!permissionArray.includes("SCAN TAB")) {
			handleGetUserById();
		}
	}, [localStorage.getItem("roleId")]);

	// console.log(!permissionArray.includes("ADMIN TAB") && !proExpertiseFlag && !proDocumentsFlag && proOnboardingFlag, "isProWelcomePage")
	// console.log(proOnboardingFlag, "--------proOnboardingFlag---------")

	useEffect(() => {
		dispatch(setUserProfileTab(1))
	}, [])



	const leftRef = useRef(null);
	const [leftHeight, setLeftHeight] = useState(0);

	useEffect(() => {
		if (leftRef.current) {
			setLeftHeight(leftRef.current.offsetHeight);
		}
	}, [flagsLoading]);

	// Pro to finish the Previous job checkin reports

	const [lastServiceRequestDetailsObj, setLastServiceRequestDetailsObj] = useState({});

	useEffect(() => {

		const getLastServiceRequestDetails = () => {
			let details = {
				scheduled_tickets_flag: 2,
			};
			dispatch(
				getCounterApi(
					details,
					(res) => {
						// console.log(res?.data?.last_service_request)
						setLastServiceRequestDetailsObj(res?.data?.last_service_request)
					},
					() => { }
				)
			);
		};

		if (permissionArray.includes("SEND VIDEO LINK") && !permissionArray.includes("VIEW COMPANY USERS")) {
			getLastServiceRequestDetails();
		}

	}, []);

	useEffect(() => {
		if (Object.keys(lastServiceRequestDetailsObj).length > 0) {
			if (lastServiceRequestDetailsObj?.summary_meta_data) {

				// debugger;
				// const finalObject = JSON.parse(JSON.parse(res?.data?.summary_meta_data));
				// const finalObjectTwo = (JSON.parse(res?.data?.summary_meta_data));

				const finalObjectTwo = (JSON.parse(lastServiceRequestDetailsObj?.summary_meta_data));

				let finalObject = {};

				// if(!Object.keys(finalObjectTwo).length > 0) {
				if (typeof (finalObjectTwo) === 'string') {
					finalObject = JSON.parse(finalObjectTwo);
				}

				console.log(finalObject, "finalObject");
				console.log(finalObjectTwo, "finalObjectTwo");

				if (Object.keys(finalObject).length > 0) {

					setServiceSummaryMetaData(finalObject);


					setProDiagnosis(finalObject?.pro_check_info?.pro_diagnosis || "");
					setProEstimatedCostMin(finalObject?.pro_check_info?.pro_estimated_cost_min || '');
					setProEstimatedCostMax(finalObject?.pro_check_info?.pro_estimated_cost_max || '');
					setProRecommendedSolution(finalObject?.pro_check_info?.pro_recommended_solution || 0);

					if (permissionArray.includes("SEND VIDEO LINK") &&
						!permissionArray.includes("VIEW COMPANY USERS") &&
						lastServiceRequestDetailsObj?.ticket_type_int == 1 &&
						(!finalObject?.pro_check_info?.pro_diagnosis || !finalObject?.pro_check_info?.pro_recommended_solution)
					) {
						setProCheckInfoModalTrigger(true);
					}

				} else if (Object.keys(finalObjectTwo).length > 0) {
					setServiceSummaryMetaData(finalObjectTwo);

					setProDiagnosis(finalObjectTwo?.pro_check_info?.pro_diagnosis || "");
					setProEstimatedCostMin(finalObjectTwo?.pro_check_info?.pro_estimated_cost_min || '');
					setProEstimatedCostMax(finalObjectTwo?.pro_check_info?.pro_estimated_cost_max || '');
					setProRecommendedSolution(finalObjectTwo?.pro_check_info?.pro_recommended_solution || 0);

					if (permissionArray.includes("SEND VIDEO LINK") &&
						!permissionArray.includes("VIEW COMPANY USERS") &&
						lastServiceRequestDetailsObj?.ticket_type_int == 1 &&
						(!finalObjectTwo?.pro_check_info?.pro_diagnosis || !finalObjectTwo?.pro_check_info?.pro_recommended_solution)
					) {
						setProCheckInfoModalTrigger(true);
					}

				} else {
					setServiceSummaryMetaData({});
				}

			}
		}
	}, [lastServiceRequestDetailsObj])

	const handleUpdateTicketSummary = (e) => {
		e?.preventDefault();

		const safeNum = (val) => isNaN(parseFloat(val)) ? 0 : parseFloat(val);


		if (!proDiagnosis.trim()) {
			setProDiagnosisErr(true);
		}

		if (!proRecommendedSolution) {
			setProRecommendedSolutionErr(true);
		}

		if (proDiagnosis && proRecommendedSolution) {
			let summary_meta_data = {
				recognized_image_summary: serviceSummaryMetaData?.recognized_image_summary || '',
				recognized_estimation_summary: serviceSummaryMetaData?.recognized_estimation_summary || '',
				recognized_repair_and_install_summary: serviceSummaryMetaData?.recognized_repair_and_install_summary || '',
				estimate_costing: {
					cost: safeNum(serviceSummaryMetaData?.estimate_costing?.cost),
					disposal_cost: safeNum(serviceSummaryMetaData?.estimate_costing?.disposal_cost),
					labor_cost: safeNum(serviceSummaryMetaData?.estimate_costing?.labor_cost),
					total_range: safeNum(serviceSummaryMetaData?.estimate_costing?.total_range),
				},
				repair_install_costing: {
					estimated_cost_by_pro: safeNum(serviceSummaryMetaData?.repair_install_costing?.estimated_cost_by_pro),
				},
				pro_check_info: {
					pro_diagnosis: proDiagnosis,
					pro_estimated_cost_min: safeNum(proEstimatedCostMin),
					pro_estimated_cost_max: safeNum(proEstimatedCostMax),
					pro_recommended_solution: proRecommendedSolution,
				},
				is_estimations_call: 0,
			}

			setUpdateTicketSummaryLoading(true);

			// setProductManualFlag(val);

			let formData = new FormData();

			formData.append("ticket_id", lastServiceRequestDetailsObj?.ticket_id_ids);
			formData.append("summary", JSON.stringify(summary_meta_data));


			dispatch(
				updateTicketSummaryApi(
					formData,
					(res) => {
						// console.log(res?.data?.data?.['Model number'], "res?.data?.data?.['Model number']");
						setUpdateTicketSummaryLoading(false);
						// console.log(res?.data?.data?.manual, "here");
						setProCheckInfoModalTrigger(false);

					},
					(res) => {
						console.log(res);
						setUpdateTicketSummaryLoading(false);

						setResponceMsg(res.data.message);
						setToasterType("error");

						setHandleToaster(true);
						setTimeout(() => {
							setHandleToaster(false);
						}, 11000);
					}
				)
			);
		}
	}


	return (
		<>
			{/* {activeCalls.length > 0 &&
				<a
					className="w-100 d-flex justify-content-center align-items-center cursor-pointer text-white font-w600 rounded-2 border-hovered"
					style={{ background: '#15b315', height: '40px', }}
					href={activeCalls[0]?.video_link_chr}
				>
					<div className="row w-100">
						<div className="col-12 px-4 d-flex justify-content-between align-items-center">
							<div className="rounded-circle" style={{ width: '15px', height: '15px', background: 'red' }}>
							</div>

							<div className="px-2">
								<span >{`${activeCalls[0]?.category_name_chr} call going on right now`}</span>
							</div>

							<div>
								<span ><i className="bi bi-chevron-right" aria-hidden="true"></i></span>
							</div>
						</div>
					</div>
				</a>
			} */}

			{!permissionArray.includes("SCAN TAB") && permissionArray.length > 0 && (
				<>
					{flagsLoading ?
						<>
							{/* <div className="d-flex justify-content-center align-items-center" style={{ height: "90dvh" }}>
								<Spinner animation="border" variant="primary" />
							</div> */}
						</> :
						<>
							{/* {!permissionArray.includes("ADMIN TAB") && !proExpertiseFlag && !proDocumentsFlag && proOnboardingFlag ? */}
							{/* Pro connecting with own customers flow changes condition removed -> (serviceRequestFlagPro != 1)) and again added*/}
							{/* {!permissionArray.includes("ADMIN TAB") && !proExpertiseFlag && !proDocumentsFlag && proOnboardingFlag && isSignUpFlag ? */}
							{!permissionArray.includes("ADMIN TAB") && !proExpertiseFlag && !proDocumentsFlag && proOnboardingFlag && serviceRequestFlagPro != 1 && isSignUpFlag ?
								<>
									{toggleForProOption ?
										<>
											<ProOptionDashboard setToggleForProOption={setToggleForProOption} />
										</> :
										<>
											<NewProDashboard />
										</>

									}
								</> :
								<>
									{proOptionFlag == 1 ?
										<>
											{permissionArray.includes("SEND VIDEO LINK") && !permissionArray.includes("VIEW COMPANY USERS") &&
												<LocalProDashboard />
											}
										</> :
										<div className="row ">
											{isServiceExpand ? (
												<div
													className="col-lg-12 px-2 my-2"
												>
													<AvailableJobs
														handleServiceExpand={handleServiceExpand}
														isServiceExpand={isServiceExpand}
														currentServiceReqId={currentServiceReqId}
													/>
												</div>
											) : (
												<div className="col-lg-12 px-2 ">
													{/* Top two cards */}
													<>
														<div className="row mx-0 w-100 mt-2">
															{/* Connect to customer Send Video Link */}
															{permissionArray.includes("SEND VIDEO LINK") && !permissionArray.includes("VIEW COMPANY USERS") &&
																<div ref={leftRef} className="col-lg-5  px-0 pe-lg-2 mt-2">
																	<SendVideoLink />
																</div>
															}

															{/* Dashboard  availability check and Service requests */}
															{permissionArray.includes("SEND VIDEO LINK") && !permissionArray.includes("VIEW COMPANY USERS") &&
																<div className={`${permissionArray.includes("SEND VIDEO LINK") ? "col-lg-7 ps-lg-2" : "col-lg-12"} col-lg-7  px-0  mt-2 d-flex flex-column`}>
																	<AvailableJobs
																		handleServiceExpand={handleServiceExpand}
																		isServiceExpand={isServiceExpand}
																		currentServiceReqId={currentServiceReqId}
																		leftHeight={leftHeight ? leftHeight : 450}
																	/>
																</div>
															}
														</div>
													</>

													{permissionArray.includes("ADMIN TAB") && <Dashboard1 />}


													{/* Bottom cards */}
													<>
														<div className="row w-100 mx-0 mt-1 mb-2">
															{/* Add Expertise */}
															<div
																className={`${serviceRequestFlagPro != 1 ? "col-lg-6 pe-lg-2" : "col-lg-12"} px-0 mt-2`}
															>
																<div className="h-100 mx-0 row">
																	<div className="col-12 px-0 ">
																		<div className="row mx-0 w-100 shadow-lg h-100" style={{ borderRadius: "14px", backgroundColor: '#FBFCFF', minHeight: '155px' }}>
																			<div className="col-12 mb-2 p-3 h-100">
																				<div className="row mx-0 h-100 position-relative">
																					<div
																						className="position-absolute bottom-0 end-0 d-flex justify-content-center align-items-center w-auto overflow-auto"
																					>
																						{serviceRequestFlagPro != 1 &&
																							<>
																								<div
																									className="rounded-circle me-2 cursor-pointer"
																									onClick={() => { setTipsSliderSteps(1); }}
																									style={{
																										width: '10px',
																										height: '10px',
																										background: tipsSliderSteps == 1 ? 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)' : 'rgba(199, 212, 234, 1)',
																									}}
																								>
																								</div>

																								<div
																									className="rounded-circle me-2 cursor-pointer"
																									onClick={() => { setTipsSliderSteps(2); }}
																									style={{
																										width: '10px',
																										height: '10px',
																										background: tipsSliderSteps == 2 ? 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)' : 'rgba(199, 212, 234, 1)',
																									}}
																								>
																								</div>

																								<div
																									className=" rounded-circle me-2 cursor-pointer"
																									onClick={() => { setTipsSliderSteps(3); }}
																									style={{
																										width: '10px',
																										height: '10px',
																										background: tipsSliderSteps == 3 ? 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)' : 'rgba(199, 212, 234, 1)',
																									}}
																								>
																								</div>


																								<div
																									className="rounded-circle me-2 cursor-pointer"
																									onClick={() => { setTipsSliderSteps(4); }}
																									style={{
																										width: '10px',
																										height: '10px',
																										background: tipsSliderSteps == 4 ? 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)' : 'rgba(199, 212, 234, 1)',
																									}}
																								>
																								</div>
																							</>
																						}

																						<div
																							className="rounded-circle me-2 cursor-pointer"
																							onClick={() => { setTipsSliderSteps(5); }}
																							style={{
																								width: '10px',
																								height: '10px',
																								background: tipsSliderSteps == 5 ? 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)' : 'rgba(199, 212, 234, 1)',
																							}}
																						>
																						</div>

																						<div
																							className=" rounded-circle me-2 cursor-pointer"
																							onClick={() => { setTipsSliderSteps(6); }}
																							style={{
																								width: '10px',
																								height: '10px',
																								background: tipsSliderSteps == 6 ? 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)' : 'rgba(199, 212, 234, 1)',
																							}}
																						>
																						</div>


																						<div
																							className="rounded-circle me-2 cursor-pointer"
																							onClick={() => { setTipsSliderSteps(7); }}
																							style={{
																								width: '10px',
																								height: '10px',
																								background: tipsSliderSteps == 7 ? 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)' : 'rgba(199, 212, 234, 1)',
																							}}
																						>
																						</div>

																						<div
																							className="rounded-circle cursor-pointer"
																							onClick={() => { setTipsSliderSteps(8); }}
																							style={{
																								width: '10px',
																								height: '10px',
																								background: tipsSliderSteps == 8 ? 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)' : 'rgba(199, 212, 234, 1)',
																							}}
																						>
																						</div>




																					</div>

																					<div className="align-items-center col-2 col-md-2 col-sm-4 d-flex justify-content-center ">
																						<div
																							className="align-items-cente   d-flex fs-2 justify-content-center  text-black"
																							style={{
																								// minHeight: "50px",
																								// minWidth: "50px",
																							}}
																						>
																							<img
																								src={
																									tipsSliderSteps == 1 ? expertiseImg :
																										tipsSliderSteps == 2 ? documentImg :
																											tipsSliderSteps == 3 ? changeAvatarImg :
																												tipsSliderSteps == 4 ? banckImg :
																													tipsSliderSteps == 5 ? targetAI :
																														tipsSliderSteps == 6 ? helpCustomerImg :
																															tipsSliderSteps == 7 ? giveFeedbackImg :
																																tipsSliderSteps == 8 ? businessImg : ''
																								}
																								alt="expertise"
																								style={{ height: "65px", width: "65px", }}
																							/>
																						</div>
																					</div>

																					<div className="col-10 col-md-10 col-sm-8 d-flex flex-column justify-content-between ps-3">
																						<div>
																							<div className="fs-4 mb-2 row fw-bold">
																								<div className="col-12 ">
																									<span className="fw-500 text-black">
																										{tipsSliderSteps == 1 ? `Add your expertise` :
																											tipsSliderSteps == 2 ? `Add your documents` :
																												tipsSliderSteps == 3 ? `Change your photo` :
																													tipsSliderSteps == 4 ? `Add your bank info` :
																														tipsSliderSteps == 5 ? `Learn AI functions` :
																															tipsSliderSteps == 6 ? `Help customers remotely` :
																																tipsSliderSteps == 7 ? `Have an idea for Chilll?` :
																																	tipsSliderSteps == 8 ? `Use Chilll for business` : ''
																										}
																									</span>
																								</div>
																							</div>

																							<div className="fs-7 mb-2 row text-black">
																								<div className="col-12">
																									<span>
																										{
																											tipsSliderSteps == 1 ? `Please add your expertise to be able to take on service requests of your speciality.` :
																												tipsSliderSteps == 2 ? `Upload your credentials so that the Chilll team can verify them. After that, you can start earning on our website.` :
																													tipsSliderSteps == 3 ? `Do you know that adding a real photo of yourself increases your chances of getting a job on the Chilll platform?` :
																														tipsSliderSteps == 4 ? `Add your bank details to be able to receive the money you earned as a Pro on the Chilll platform.` :
																															tipsSliderSteps == 5 ? `AI functions are designed to make the use of Chilll services as convenient as possible.` :
																																tipsSliderSteps == 6 ? `As a Pro, you can easily connect to your customers through Chilll services and help them remotely.` :
																																	tipsSliderSteps == 7 ? `We'd love to hear from you with any thoughts and suggestions you have about the Chilll services.` :
																																		tipsSliderSteps == 8 ? `The Chilll services will help your business reach a new level of development and prosperity.` : ''
																										}
																									</span>
																								</div>
																							</div>
																						</div>
																						<div className="d-flex font-w500 fs-6 row mb-3">
																							<div className="col-md-8 pe-2 " style={{}}>
																								<div className="d-flex">
																									<div
																										onClick={() => {
																											// navigate("/userProfile");
																											handleOpenTipsModal();
																										}}
																										className="align-items-center font-w500 rounded-1 cursor-pointer d-flex text-hovered px-1 py-2 overlay-action-btn"
																									>
																										<span>{
																											tipsSliderSteps == 1 ? `Add expertise` :
																												tipsSliderSteps == 2 ? `Add documents` :
																													tipsSliderSteps == 3 ? `Change photo` :
																														tipsSliderSteps == 4 ? `Add bank info` :
																															tipsSliderSteps == 5 ? `Learn more` :
																																tipsSliderSteps == 6 ? `Connect to customer` :
																																	tipsSliderSteps == 7 ? `Give feedback` :
																																		tipsSliderSteps == 8 ? `Learn more` : ''
																										} </span>
																										<i className="bi bi-chevron-right ps-2 hovered-arrow"></i>
																									</div>
																								</div>
																							</div>
																							<div className="col-md-4"></div>
																						</div>
																					</div>

																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>

															{/* Earning */}
															{serviceRequestFlagPro != 1 &&
																<div className="col-lg-6 ps-lg-2 px-0 mt-2 ">
																	<div className="h-100 mx-0 row shadow-lg  " style={{ borderRadius: "14px", backgroundColor: '#FBFCFF' }}>
																		<div className="col-12 px-0">
																			<div className="w-100  h-100 ">
																				<div className="col-12 mb-2 p-3 h-100">
																					<div className="row mx-0 h-100">
																						<div className="align-items-center col-2 col-md-2 col-sm-4 d-flex justify-content-center ">
																							<div
																								className="align-items-cente  d-flex fs-2 justify-content-center text-black"
																								style={{
																									// minHeight: "50px",
																									// minWidth: "50px",
																								}}
																							>
																								<img src={earningsImg} alt="expertise" style={{ height: "50px", width: "50px" }} />
																								{/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
																							</div>
																						</div>

																						<div className="col-10 col-md-10 col-sm-8 d-flex flex-column justify-content-between">
																							<div>
																								<div className="fs-4 mb-2 row">
																									<div className="col-12 ">
																										<span className="fw-500 text-black">
																											{"Wallet balance: "}
																										</span>
																										<span className="fw-bold text-green">
																											{`${USDollar.format((availableBalanceObj?.available?.[0]?.amount / 100) || 0)}`}
																										</span>
																									</div>
																								</div>
																								<div className="fs-7 mb-2 row text-black">
																									<div className="col-6">
																										<span>{`Total earnings: `}</span>
																										<span className="fw-bold">{`${permissionArray.includes("VIEW REGISTERED COMPANIES LIST") ? USDollar.format(totalEarning) : USDollar.format(totalProEarnings)}`}</span>
																									</div>

																									<div className="col-6">
																										{permissionArray.includes("VIEW REGISTERED COMPANIES LIST") && <>
																											<span>{`Platform fees: `}</span>
																											<span className="fw-bold">{`${USDollar.format(totalFees)}`}</span>
																										</>}
																									</div>
																								</div>

																								{permissionArray.includes("VIEW REGISTERED COMPANIES LIST") &&
																									<div className="fs-7 mb-2 row text-black">
																										<div className="col-6">
																											<span>{`Total pro earnings: `}</span>
																											<span className="fw-bold">{`${USDollar.format(totalProEarnings)}`}</span>
																										</div>

																										<div className="col-6">
																											{permissionArray.includes("VIEW REGISTERED COMPANIES LIST") && <>
																												<span>{`Refunds: `}</span>
																												<span className="fw-bold">{`${USDollar.format(refundAmount)}`}</span>
																											</>}
																										</div>
																									</div>
																								}
																							</div>

																							<div className="d-flex font-w500 fs-7 row">
																								<div
																									className="col-md-8 pe-2 "
																									style={{
																										// pointerEvents: "none",
																										// opacity: "0.5",
																										pointerEvents: availableBalanceObj?.available?.[0]?.amount > 0 && connectedAccountId && connectedAccStatus && cardPaymentsCheck && transfersCheck ? "auto" : "none",
																										opacity: availableBalanceObj?.available?.[0]?.amount > 0 && connectedAccountId && connectedAccStatus && cardPaymentsCheck && transfersCheck ? "1" : "0.5",
																									}}>
																									<PrimaryButton
																										onClick={() => {
																											navigate("/userProfile");
																										}}
																										style={{
																											width: "100%",
																											background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
																											border: '2px solid rgba(255, 154, 32, 1)',
																											boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
																										}}
																										buttonName={"GET PAID NOW"}
																									/>
																								</div>
																								<div className="col-md-4"></div>
																							</div>
																						</div>


																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															}
														</div>
													</>
												</div>
											)}
										</div>
									}
								</>
							}
						</>}
				</>
			)}

			{
				permissionArray.includes("SCAN TAB") && permissionArray.length > 0 && (
					<>

						<div
							className="row d-flex justify-content-center align-items-center overflow-auto"
							style={{ height: 'calc(100dvh - 100px)' }}
						>
							<CustomerDashboard />
						</div>
					</>
				)
			}
			{
				permissionArray.length > 0 && (
					<div className="home-container" style={{ marginRight: "15px" }}></div>
				)
			}

			{/* Modal for tips and tricks */}
			<>
				<Modal className="fade" show={tipsModalTrigger} size="sm" centered
				// onHide={handleClose} 
				>
					<Modal.Body>
						<div className="row mx-0">
							<div className="col-12 px-0">

								<div className='mx-0 row text-black'>

									<div className='col-12 d-flex fs-4 justify-content-end px-0'>
										<span onClick={() => handleCloseTipsModal()} className='cursor-pointer'>
											<i className="bi bi-x-lg text-hovered"></i>
										</span>
									</div>
								</div>

								<div className='mx-0 row text-black mb-3'>
									<div className='col-12 font-w600 fs-3 px-0 text-center d-flex justify-content-center align-items-center'>
										<img
											src={
												tipsSliderSteps == 1 ? expertiseImg :
													tipsSliderSteps == 2 ? documentImg :
														tipsSliderSteps == 3 ? changeAvatarImg :
															tipsSliderSteps == 4 ? banckImg :
																tipsSliderSteps == 5 ? targetAI :
																	tipsSliderSteps == 6 ? helpCustomerImg :
																		tipsSliderSteps == 7 ? giveFeedbackImg :
																			tipsSliderSteps == 8 ? businessImg : ''
											}
											alt="expertise"
											style={{ height: "105px", width: "105px" }}
										/>
									</div>
								</div>

								<div className='mx-0 row text-black mb-3'>
									<div className='col-12 font-w600 fs-3 px-0 text-center'>
										<span>
											{tipsSliderSteps == 1 ? `Add your expertise` :
												tipsSliderSteps == 2 ? `Add your documents` :
													tipsSliderSteps == 3 ? `Change your photo` :
														tipsSliderSteps == 4 ? `Add your bank info` :
															tipsSliderSteps == 5 ? `Learn AI functions` :
																tipsSliderSteps == 6 ? `Help customers remotely` :
																	tipsSliderSteps == 7 ? `Have an idea for Chilll?` :
																		tipsSliderSteps == 8 ? `Use Chilll for business` : ''
											}
										</span>
									</div>
								</div>

								<div className='mx-0 row mb-4'>
									<div className='col-12  px-0 text-center'>
										<span>
											{
												tipsSliderSteps == 1 ? `Please add your expertise to be able to take on service requests of your speciality.` :
													tipsSliderSteps == 2 ? `Upload your credentials so that the Chilll team can verify them. After that, you can start earning on our website.` :
														tipsSliderSteps == 3 ? `Do you know that adding a real photo of yourself increases your chances of getting a job on the Chilll platform?` :
															tipsSliderSteps == 4 ? `Add your bank details to be able to receive the money you earned as a Pro on the Chilll platform.` :
																tipsSliderSteps == 5 ? `AI functions are designed to make the use of Chilll services as convenient as possible.` :
																	tipsSliderSteps == 6 ? `As a Pro, you can easily connect to your customers through Chilll services and help them remotely.` :
																		tipsSliderSteps == 7 ? `We'd love to hear from you with any thoughts and suggestions you have about the Chilll services.` :
																			tipsSliderSteps == 8 ? `The Chilll services will help your business reach a new level of development and prosperity.` : ''
											}

										</span>
									</div>
								</div>

								<div className='mx-0 row mt-3'>
									<div className='col-12  px-0 text-center'>
										<PrimaryButton
											needIcon={true}
											iconClassName={"bi bi-arrow-right"}
											buttonName={
												tipsSliderSteps == 1 ? `ADD EXPERTISE` :
													tipsSliderSteps == 2 ? `ADD DOCUMENTS` :
														tipsSliderSteps == 3 ? `CHANGE PHOTO` :
															tipsSliderSteps == 4 ? `ADD BANK INFO` :
																tipsSliderSteps == 5 ? `LEARN MORE` :
																	tipsSliderSteps == 6 ? `CONNECT TO CUSTOMER` :
																		tipsSliderSteps == 7 ? `GIVE FEEDBACK` :
																			tipsSliderSteps == 8 ? `LEARN MORE` : ''
											}
											onClick={() => {
												if (tipsSliderSteps == 1 || tipsSliderSteps == 2 || tipsSliderSteps == 3 || tipsSliderSteps == 4) {
													navigate("/userProfile");
													if (tipsSliderSteps == 1) {
														dispatch(setExpertiseTriggerRedux(true));
													} else if (tipsSliderSteps == 2) {
														dispatch(setDocumentsModalTriggerRedux(true));
													} else if (tipsSliderSteps == 3) {
														dispatch(setAccountDetailsModalTriggerRedux(true));
													} else if (tipsSliderSteps == 4) {
														if (permissionArray.includes("UPDATE WORK INFORMATION")) {
															dispatch(setUserProfileTab(3));
														}
													}
												} else if (tipsSliderSteps == 5 || tipsSliderSteps == 8) {
													navigate("/tipsAndTricks");
												} else if (tipsSliderSteps == 6) {
													handleCloseTipsModal();
												} else if (tipsSliderSteps == 7) {
													handleCloseTipsModal();
													dispatch(setFeedbackModalRedux(true));
												}
											}}
											style={{
												width: '100%',
												background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
												border: '2px solid rgba(255, 154, 32, 1)',
												boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
											}}
										/>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>
				</Modal>
			</>

			{/* Modal for the taking check in for the last service request */}
			<Modal className='fade' centered show={proCheckInfoModalTrigger} size="lg">
				<Modal.Body>
					<div className='row mx-0'>
						<div className='col-12 px-0'>
							<>
								<div className='mx-0 row text-black mb-4'>
									<div className='col-11 font-w600 fs-3 px-0 text-center'>
										<span>
											{`Check-in report for service request #${lastServiceRequestDetailsObj?.display_id_int}`}
										</span>
									</div>
									<div className='col-1 d-flex fs-4 justify-content-end px-0'>
										<span onClick={() => setProCheckInfoModalTrigger(false)} className='cursor-pointer fs-4 text-black text-hovered'>
											<i className="bi bi-x-lg"></i>
										</span>
									</div>
								</div>

								<div className='mx-0 row mb-4'>
									<div className='col-12 font-w600 fs-5 px-0 text-center'>
										<span>
											{`Please fill the information below to complete the check-in for your last service request (#${lastServiceRequestDetailsObj?.display_id_int})`}
										</span>
									</div>
								</div>



								<div className='mx-0 row'>
									<div
										className="col-md-6 pe-md-3 fs-6"
										style={{ borderRight: '2px solid black' }}
									>
										<div className=" mb-3">
											<div>
												<span className="text-black font-w600">{`Attachment : `}</span>
												{!lastServiceRequestDetailsObj?.image_url && <span className="font-w500">{`No attachment found`}</span>}
											</div>

											{lastServiceRequestDetailsObj?.image_url &&
												<div className="d-flex justify-content-center align-items-center bg-light rounded-2" >
													<img
														className="w-100 rounded-2"
														style={{
															objectFit: 'contain',
															maxHeight: '250px',
															height: '250px'
														}}
														src={lastServiceRequestDetailsObj?.image_url}
														alt="No attachments found"
													/>
												</div>
											}
										</div>

										<div className="mb-2">
											<span className="text-black font-w600">{`Problem description : `}</span>
											<span className="font-w500">{`${lastServiceRequestDetailsObj?.problem_description_chr}`}</span>
										</div>
										<div className="mb-2">
											<span className="text-black font-w600">{`Summary : `}</span>
											<span className="font-w500">{`${serviceSummaryMetaData?.recognized_image_summary || 'No summary found'}`}</span>
										</div>

										<div className="mb-2">
											<span className="text-black font-w600">{`Created on : `}</span>
											<span className="font-w500">
												{`${lastServiceRequestDetailsObj?.created_date_dtm ?
													new Intl.DateTimeFormat("en-US", {
														year: "numeric",
														month: "short",
														day: "numeric",
														hour: 'numeric',
														minute: 'numeric',
														hour12: true
													}).format(
														lastServiceRequestDetailsObj?.created_date_dtm * 1000
													) : '-'}`}
											</span>
										</div>


									</div>

									<div className="col-md-6 ps-md-3">
										<form
											onSubmit={(e) => {
												handleUpdateTicketSummary(e)
											}}
											className="mt-1"
										>
											<div className='row mb-4'>
												<div className='col-12 px-0'>
													<div className="row mx-0">
														<div className="row">
															<div className="col-12 px-0">
																<TextArea
																	labelName={"Diagnosis *"}
																	placeholderName={"Diagnosis"}
																	value={`${proDiagnosis}`}
																	onChange={(e) => { handleProDiagnosis(e) }}
																	onBlur={() => { }}
																	errorOccured={proDiagnosisErr}
																	errorMessage={"Please add Diagnosis"}
																	isRequired={true}
																	rows={3}
																/>
															</div>
														</div>

														<div className="row">
															<div className="col-12 px-0 mb-2">
																<span className="fs-5 text-black font-w500">{`Estimated Cost Range`}</span>
															</div>

															<div className="row">
																<div className="col-6 px-0 pe-2">
																	<InputField
																		labelName={"Low ($)"}
																		placeholderName={"Low ($)"}
																		value={`${proEstimatedCostMin}`}
																		onChange={(e) => { handleProEstimatedCostMin(e) }}
																		onBlur={() => { }}
																		errorOccured={false}
																		errorMeesage={"Please add Labor"}
																	/>
																</div>
																<div className="col-6 px-0 ps-2">
																	<InputField
																		labelName={"High ($)"}
																		placeholderName={"High ($)"}
																		value={`${proEstimatedCostMax}`}
																		onChange={(e) => { handleProEstimatedCostMax(e) }}
																		onBlur={() => { }}
																		errorOccured={false}
																		errorMeesage={"Please add Labor"}
																	/>
																</div>
															</div>
														</div>

														<div className="row">
															<div className="col-12 px-0 mb-3">
																<span className="fs-5 text-black font-w500">{`Solution recommendation`}</span>
															</div>

															<div className="row">
																<div
																	className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
																	onClick={() => {
																		setProRecommendedSolution(1);
																	}}
																	style={{
																		border: proRecommendedSolution == 1 ? "2px solid orange" : "2px solid lightgray",
																		background: proRecommendedSolution == 1 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
																		color: proRecommendedSolution == 1 ? "white" : "black",
																	}}
																>
																	<span className="fs-5 font-w600 text-center">{`DIY with Chilll Toolbox`}</span>
																	<span className="fs-6 text-center">{`Free`}</span>
																</div>

																<div
																	className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
																	onClick={() => {
																		setProRecommendedSolution(2);
																	}}
																	style={{
																		border: proRecommendedSolution == 2 ? "2px solid orange" : "2px solid lightgray",
																		background: proRecommendedSolution == 2 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
																		color: proRecommendedSolution == 2 ? "white" : "black",
																	}}
																>
																	<span className="fs-5 font-w600 text-center">{`DIY with Remote Pro`}</span>
																	<span className="fs-6 text-center">{`$25 for 20 minutes`}</span>
																</div>

																<div
																	className="col-12 px-0 d-flex align-items-center justify-content-center mb-2 flex-column p-2 bg-light rounded-3 cursor-pointer overlay-action-btn border-hovered"
																	onClick={() => {
																		setProRecommendedSolution(3);
																	}}
																	style={{
																		border: proRecommendedSolution == 3 ? "2px solid orange" : "2px solid lightgray",
																		background: proRecommendedSolution == 3 ? "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)" : "",
																		color: proRecommendedSolution == 3 ? "white" : "black",
																	}}
																>
																	<span className="fs-5 font-w600 text-center">{`Get Local Pro`}</span>
																	<span className="fs-6 text-center">{`Free matching on your terms`}</span>
																</div>
															</div>

															{proRecommendedSolutionErr &&
																<div>
																	<span className="text-danger font-w500 fs-12">{`Please select one of the above options`}</span>
																</div>
															}
														</div>



													</div>
												</div>
											</div>

											<div className='row mx-0 mt-2'>
												<div className='col-12 px-0'>
													<PrimaryButton
														onClick={(e) => {
															handleUpdateTicketSummary(e);
														}}
														buttonName={"SUBMIT"}
														type="submit"
														loadingMessage="SUBMITTING..."
														isLoading={updateTicketSummaryLoading}
														style={{
															width: "100%",
															background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
															boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
															border: '1px solid rgba(255, 154, 32, 1)',
															fontWeight: '600',
														}}
													/>
												</div>
											</div>

										</form>
									</div>
								</div>


							</>

						</div>
					</div>
				</Modal.Body>
			</Modal >

			{
				handleToaster && (
					<ResponceToaster toasterType={toasterType} message={responceMsg} />
				)
			}


		</>
	);
};
export default Home;

// <div className="col-6">
// <span className="fs-6" style={{fontWeight:'600'}}>Add new note</span>
// </div>
// <div className="col-6 d-flex justify-content-end">
// <span className="fs-7"><RxCross2 style={{width:"18px",height:'18px'}}/> </span>
// </div>
// </div>
// <div className="row mx-0  mt-4" >
// <TextArea
// labelName={txtMessage}
// value={discussionVal}
// onChange={discussionOnChange}
// />
// </div>
// </div>
// <div className="row mx-0  mt-2 py-2" style={{borderTop:"1px solid rgba(241, 241, 241, 1)",borderBottom:"1px solid rgba(241, 241, 241, 1)"}}>
// <div className="col-6">
// <span className="fs-6" >Image.png</span>
// </div>
// <div className="col-6 d-flex justify-content-end">
// <span className="fs-7"><MdDeleteOutline style={{width:"18px",height:'18px'}}/> </span>
// </div>
// </div>
